import { Action } from 'redux';

import { ReduxRouterErrorState } from '../../app/state/ReduxRouterErrorState';
import { isHideRouterErrorAction, isShowRouterErrorAction } from '../actions/RouterErrorActions';

const InitialState: ReduxRouterErrorState = {
  displayError: false,
  errorType: 'default',
  redirectSiteUrlName: ''
};

export function routerErrorReducer(
  previousState: ReduxRouterErrorState = InitialState,
  action: Action = null
): ReduxRouterErrorState {

  if (isShowRouterErrorAction(action)) {
    return {
      displayError: true,
      errorType: action.errorType,
      redirectSiteUrlName: action.redirectSiteUrlName
    };
  }

  if (isHideRouterErrorAction(action)) {
    return InitialState;
  }

  return previousState;
}
